import {defaultCountry, countryTextMap} from './../config/app-config';

export default function autosuggestOnSelectionhandler(
  changes,
  updateQueryCaller,
  updatePropertyDetails,
) {
  let country = defaultCountry;
  if (changes && changes.selectedItem && changes.selectedItem.xtr?.cc) {
    country = changes.selectedItem.xtr?.cc || '';
    if (changes.selectedItem.xtr.flt) {
      // ! if there is an explicit product ask
      // ! otherwise, filter stuff coming from voyager will anyway get consumed at UpdateSearch level
      // const voyagerTransformedFilter = voyagerResultToFilter(
      //   changes.selectedItem,
      //   filterInState,
      // );
      // updateFilterCaller({...voyagerTransformedFilter});
    }
  }

  if (changes.selectedItem?.t === 'hotel') {
    updatePropertyDetails({
      propertyId: changes.selectedItem?._id,
      propertyName: changes.selectedItem?.n,
    });
  } else {
    updatePropertyDetails({
      // resetFlag: true
      propertyId: '',
      propertyName: '',
    });
  }

  updateQueryCaller({
    destination: {...changes.selectedItem},
    country: country,
  });
}
